import { useMemo } from 'react';
import { useRateGroups } from '../../../../../../queries';
import { getEntitiesExternalIdentifiersIntersection, getExternalIdentifiersGroups } from '../../../../../../utilities';

export const useRateGroupsExternalIdentifiersIntersection = (enterpriseIds: string[]) => {
    const { data, isFetching } = useRateGroups(enterpriseIds);
    const memoData = useMemo(() => {
        const externalIdentifiersGroups = data ? getExternalIdentifiersGroups(data.rateGroups) : [];
        const hasAllEnterprisesSomeRateGroups = enterpriseIds.length === externalIdentifiersGroups.length;

        return hasAllEnterprisesSomeRateGroups
            ? getEntitiesExternalIdentifiersIntersection(externalIdentifiersGroups)
            : [];
    }, [data, enterpriseIds]);

    return {
        isFetching,
        data: memoData,
    };
};
